import * as React from "react";
import { CmsHeadTags } from "@grandvisionhq/bloomreach";
import { ProfilePage } from "@grandvisionhq/my-account";
import { useIntl } from "@grandvisionhq/state";
import { P as ProtectedPageLayout } from "../../protected-page.js";
const Page = ({
  shouldShowOrderDate = true
}) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(ProtectedPageLayout, { pageKey: "profile" }, /* @__PURE__ */ React.createElement(CmsHeadTags, { title: getLabel("account.menu.accountDetails"), noFollow: true, noIndex: true }), /* @__PURE__ */ React.createElement(ProfilePage, { shouldShowOrderDate }));
};
export {
  Page
};
//# sourceMappingURL=profile.js.map
